document.addEventListener('DOMContentLoaded', () => {
  const moreInfo = document.querySelector('.collection-banner__more-info');
  const description = document.querySelector('.collection-banner__text-container-text');
  const { innerWidth } = window;

  if (moreInfo && description) {
    moreInfo.addEventListener('click', () => {
      description.classList.toggle('hidden');
      moreInfo.classList.toggle('open');
    });

    if (innerWidth < 766) {
      description.classList.add('hidden');
      moreInfo.classList.remove('open');
    }
  }
});
